const LRU = require('lru-cache')

const store = new LRU({
  maxAge: Infinity,
  max: 0,
})
let expiration = 30 * 60 * 1000
const cacheTimeouts = {}
/**
 * @param {string} key  - key to be stored
 * @param {*} value - any type (stored value)
 * @param {function} timeOutCallback - function callback
 * @param {number} exp - expiration time in milliseconds - default is 30 * 60 * 1000
 *
 * @returns {string} value
 */
function put(key, value, timeOutCallback, exp) {
  if (exp && typeof exp === 'number' && exp >= 0) {
    expiration = exp
  }
  if (timeOutCallback && typeof timeOutCallback !== 'function') {
    throw new Error('Cache timeout callback must be a function')
  }
  let rec = cacheTimeouts[key]
  if (rec) clearTimeout(rec.timeout)
  const expire = expiration + Date.now()
  rec = {
    value,
    expire,
    timeout: setTimeout(() => {
      store.del(key)
      if (timeOutCallback) {
        timeOutCallback(key, value)
      }
    }, expiration),
  }
  store.set(key, value)
  cacheTimeouts[key] = rec
  return value
}

module.exports = {
  /**
   * @param {string} key  - key to get fomr cache
   *
   * @returns {string} value corresponding to key
   */
  get: key => store.get(key),
  /**
   * @param {string} key  - key to get fomr cache
   * @param {*} value - any type (stored vale)
   *
   * @returns {string} value corresponding to key
   */
  set: (key, value) => store.set(key, value),
  /**
   * @param {string} key  - key to get from cache
   *
   * @returns {undefined}
   */
  del: key => store.del(key),
  put,
}
